<template>
  <div class="content">
    <div class="container-fluid">
      <!--<OrganizationChart :value="data1" :collapsible="true" class="company" selectionMode="single" :selectionKeys.sync="selection"
          @node-select="onNodeSelect" @node-unselect="onNodeUnselect" @node-collapse="onNodeCollapse" @node-expand="onNodeExpand">
          <template #person="slotProps">
              <div class="node-header ui-corner-top">{{slotProps.node.data.label}}</div>
              <div class="node-content">
                  <img :src="slotProps.node.data.avatar" width="32">
                  <div>{{slotProps.node.data.name}}</div>
              </div>
          </template>
          <template #default="slotProps">
              <span>{{slotProps.node.data.label}}</span>
          </template>
      </OrganizationChart>-->



      <a-spin :spinning="loading" :delay="500">
        <div class="spin-content">
          <OrganizationChart v-if="req_complete" :value="data" :collapsible="true" class="company" selectionMode="single" :selectionKeys.sync="selection"
            @node-select="onNodeSelect" @node-unselect="onNodeUnselect" @node-collapse="onNodeCollapse" @node-expand="onNodeExpand">
            <template #person="slotProps">
                <div class="node-header ui-corner-top">{{slotProps.node.data.label}}</div>
                <div class="node-content">
                    <div v-html="slotProps.node.data.name"></div>
                </div>
            </template>
            <template #default="slotProps">
                <span>{{slotProps.node.data.label}}</span>
            </template>
        </OrganizationChart>
        </div>
      </a-spin>
    </div>
    <a-modal
      :title="modal.title"
      :visible="modal.visible"
      :confirm-loading="modal.confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
        >
          <a-form-model-item ref="name" label="İsim" prop="name">
            <a-input
              placeholder="İsim"
              v-model="form.name"
              @blur="
                () => {
                  $refs.name.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
        </a-form-model>
      </p>
    </a-modal>
  </div>
</template>
<script>
  import OrganizationChart from 'primevue/organizationchart';
  export default {
     mounted() {
      console.log("mounted organization chart")
      const self = this
      self.requestChartData()
    },
    computed: {

    },
    components: {
      OrganizationChart
    },
    methods: {
      requestChartData(){
        const self = this;
        self.loading = true
        self.$store.dispatch("Segments/requestSegmentIndex").then((a) => {
          self.$store.dispatch("Segments/requestSegmentTypeIndex").then((b) => {
            self.segments = a.segments
            self.segmentTypes = b.segmentTypes
            self.configureChart()
            self.loading = false
          })
        })
      },
      handleOk(e) {
        const self = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            self.confirmLoading = true
            self.$store.dispatch("Segments/requestSegmentCreate", {
              name: self.form.name,
              top_segment_id: self.modal.top_id,
              segment_type_id: self.modal.node_type_id
            }).then((user)=> {
              self.$notification['success']({
                message: 'Segment Ekleme',
                description:
                  'Segment başarılı bir şekilde oluşturuldu :)',
              });
              self.requestChartData()
              self.handleCancel();

            }).catch(()=> {
              self.$notification['error']({
                message: 'Segment Ekleme',
                description:
                  'Segment eklenirken bir hata oluştu :/',
              });
            }).finally(()=> {
              self.modal.confirmLoading = false
            })
          }
        })
      },
      handleCancel(e) {
        console.log("asda sdkas kdas da")
        const self = this;
        self.modal = {
          title: '',
          visible: false,
          text: '',
          confirmLoading: false,
          top_id: null,
          node_type_id: null,
        }
        self.form.name = ''
      },
      configureChart(){
        const self = this
        console.log(self.segments, self.segmentTypes)

        var data = {}

        //main node
        let main_node_type = self.segmentTypes.sort(function(a, b) { 
          return a.rank - b.rank
        })[0];
        data.type = "person";
        data.styleClass = "p-person";
        let main_node = self.segments.find(item => item.segment_type_id == main_node_type.id)
        data.key = main_node.id;
        data.data = {new: false, label: main_node_type.name, name: main_node.name}

        var next = self.getChildren(main_node.id)
        data.children = next

        console.log("data.children: ", data)

        self.data = data
        self.req_complete = true

      },
      getChildren(top_id){
        const self = this
        var s_segments = self.segments.filter(item => item.top_segment_id == top_id )
        var children = [];
        console.log(s_segments)

        var node_type = {}

        s_segments.forEach((item) => {

          node_type = self.segmentTypes.find(a => a.id == item.segment_type_id)
          let child_data = {
            key: top_id+'_'+item.id,
            type: "person",
            styleClass: "p-person",
            data: {new: false, label: node_type ? node_type.name : 'no-name', name: item.name, top_id: top_id, node_type_id: node_type.id}
          }

          let next = self.getChildren(item.id)
          child_data.children = next

          children.push(child_data)
        })
        if(s_segments.length){
          children.push({
            key: top_id+'_'+self.$randUniqueID(),
            type: "person",
            styleClass: "p-person",
            data: {new: true, label: (node_type ? 'Yeni '+ node_type.name : 'Yeni'), name: '<i class="p-node-toggler-icon pi pi-plus-circle"></i>', top_id: top_id, node_type_id: node_type.id}
          })
        }
        return children
      },
      onNodeSelect(node) {
        if(!node.data.new) return
        this.configureModal(node)
      },
      onNodeUnselect(node) {
        if(!node.data.new) return
        this.configureModal(node)
      },
      configureModal(node){
        const self = this
        self.modal.title = node.data.label+ " Oluştur"
        self.modal.visible = true
        self.modal.top_id = node.data.top_id
        self.modal.node_type_id = node.data.node_type_id
      },
      onNodeExpand(node) {
        console.log('Node Expanded: ', node.data.label)
      },
      onNodeCollapse(node) {
        console.log('Node Collapsed: ', node.data.label)
      }
    },
    data () {
      return {
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
        other: '',
        form: {
          name: '',
        },
        rules: {
          name: [
            { required: true, message: 'İsim alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 20, message: 'İsim alanı min 3, max 20 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
        },
        modal: {
          title: '',
          visible: false,
          text: '',
          confirmLoading: false,
          top_id: null,
          node_type_id: null,
        },
        segments: [],
        segmentTypes: [],
        req_complete: false,
        loading: false,
        data: {},
        data1: {
            key: '0',
            type: 'person',
            styleClass: 'p-person',
            data: {label: 'CEO', name: 'Walter White', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/walter.jpg'},
            children: [
                {
                    key: '0_0',
                    type: 'person',
                    styleClass: 'p-person',
                    data: {label: 'CFO', name:'Saul Goodman', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/saul.jpg'},
                    children:[{
                        key: '0_0_0',
                        data: {label: 'Tax'},
                        selectable: false,
                        styleClass: 'department-cfo'
                    },
                    {
                        key: '0_0_1',
                        data: {label: 'Legal'},
                        selectable: false,
                        styleClass: 'department-cfo'
                    }],
                },
                {
                    key: '0_1',
                    type: 'person',
                    styleClass: 'p-person',
                    data: {label: 'COO', name:'Mike E.', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/mike.jpg'},
                    children:[{
                        key: '0_1_0',
                        data: {label: 'Operations'},
                        selectable: false,
                        styleClass: 'department-coo'
                    }]
                },
                {
                    key: '0_2',
                    type: 'person',
                    styleClass: 'p-person',
                    data: {label: 'CTO', name:'Jesse Pinkman', avatar: 'https://www.primefaces.org/primevue-v2/demo/images/organization/jesse.jpg'},
                    children:[{
                        key: '0_2_0',
                        data: {label: 'Development'},
                        selectable: false,
                        styleClass: 'department-cto',
                        children:[{
                            key: '0_2_0_0',
                            data: {label: 'Analysis'},
                            selectable: false,
                            styleClass: 'department-cto'
                        },
                        {
                            key: '0_2_0_1',
                            data: {label: 'Front End'},
                            selectable: false,
                            styleClass: 'department-cto'
                        },
                        {
                            key: '0_2_0_2',
                            data: {label: 'Back End'},
                            selectable: false,
                            styleClass: 'department-cto'
                        }]
                    },
                    {
                        key: '0_2_1',
                        data: {label: 'QA'},
                        selectable: false,
                        styleClass: 'department-cto'
                    },
                    {
                        key: '0_2_2',
                        data: {label: 'R&D'},
                        selectable: false,
                        styleClass: 'department-cto'
                    }]
                }
            ]
        },
        selection: {}
      }
    }
  }
</script>
<style lang="scss" scoped>
  .spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
  }
  :deep(.p-organizationchart) {
    .p-person {
        padding: 0;
        border: 0 none;
    }

    .node-header, .node-content {
        padding: .5em .7rem;
    }

    .node-header {
        background-color: #495ebb;
        color: #ffffff;
    }

    .node-content {
        text-align: center;
        border: 1px solid #dee2e6;
        div {
          margin: 5px 0;
          color: #888888;
        }
    }

    .node-content img {
        border-radius: 50%;
    }
}
</style>
